module.exports = __webpack_public_path__ + "img/user-trip.08d66967.png";